import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { StoreService } from './shared/services/store/store.service';
import { authInterceptor } from './interceptors/auth/auth.interceptor';
import { provideNgxMask } from 'ngx-mask';

/**
 * Initialize the style service on application bootup
 */
function initializeStore(storeService: StoreService) {
  return () => storeService.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideNgxMask(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeStore,
      deps: [StoreService],
      multi: true,
    },
  ],
};
